
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Icon/Send"}},[_c('path',{attrs:{"id":"Union","fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.2476 8.36668L5.7864 14.1503L12.4599 18.1544L22.2476 8.36668ZM14.3455 20.0401L18.3494 26.7134L24.1329 10.2526L14.3455 20.0401ZM28.3609 6.2638C28.8244 4.94457 27.5552 3.67537 26.236 4.13889L2.89397 12.3401C1.56245 12.808 1.37877 14.6156 2.58896 15.3417L11.6946 20.8051L17.1581 29.9108C17.8842 31.121 19.6918 30.9373 20.1596 29.6058L28.3609 6.2638Z","fill":"#7344C0"}})])])
          )
        }
      }
    